import styled from 'styled-components'
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ChatIcon from '@material-ui/icons/Chat';

export const CmtItem = styled.li`
    padding: 12px;
    margin-left: ${({type}) => type === 'reply' ? '20px':''};
    padding-left: ${({type}) => type === 'reply' ? '20px':''};
    border-left: ${({type}) => type === 'reply' ? '1px dotted #bbb':''};
    position: relative;
    
    &:before {
        content: '';
        height: 100%;
        border-left: 1px dotted #bbb;
        position: absolute;
        left: -1px;
        top: 0;
        display: ${({type}) => type === 'reply' ? 'block':'none'};
    }

    &:after {
        content: '';
        height: 100%;
        border-left: 1px dotted #bbb;
        position: absolute;
        left: 1px;
        top: 0;
        display: ${({type}) => type === 'reply' ? 'block':'none'};
    }

`

export const CmtItemTop = styled.div``

export const UserAvatar = styled.img`
    float: left;
    margin-right: 10px;
    width: 33px;
    height: 33px;
`

export const CmtItemBody = styled.div``

export const Username = styled.p`
    font-size: 14px;
    font-weight: bold;
    color: #e32;
    margin-bottom: 3px;

    @media screen and (max-width: 767px) {
        font-size: 13px;
    }
`

export const CmtContent = styled.p`
    font-size: 14px;
    line-height: 1.43;
    color: #606060;
`

export const CmtItemBottom = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 6px;
`

export const CmtItemBottomLeft = styled.div`
    display: flex;
`

export const LikeButton = styled.div`
    cursor: pointer;
    color: #727b88;
    font-size: 12px;
    display: flex;
    align-items: center;
    margin-right: 22px;

    &.active {
        color: #e32;
    }
`

export const LikeIc = styled(ThumbUpIcon)`
    font-size: 14px !important;
    margin-right: 5px;
`

export const RelplyButton = styled.div`
    cursor: pointer;
    color: #727b88;
    font-size: 12px !important;
    display: flex;
    align-items: center;
`

export const CommentIc = styled(ChatIcon)`
    font-size: 14px !important;;
    margin-right: 2px;
`

export const CmtItemBottomRight = styled.div`
    display: flex;
    color: #727b88;
    font-size: 12px;
`

export const ReplyTotal = styled.p`
    margin-right: 22px;
`

export const TimeAgo = styled.p``